import * as t from './actionTypes';
import * as api from './api';

export function loadChats(successCB, errorCB) {
    return (dispatch) => {
        api.getChats(function (success, chats, error) {
            if (success) {
                dispatch({ type: t.CHAT_LOAD_SUCCESS, chats: chats });
                successCB();
            } else if (error)
                errorCB(error);
        })
    }
}

export function createNewChat(data, successCB, errorCB) {
    return (dispatch) => {
        api.createNewChat(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.CHAT_CREATE_SUCCESS, chat: data });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function sendImageToChat(data, successCB, errorCB) {
    return (dispatch) => {
        api.sendImageToChat(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.CHAT_CREATE_SUCCESS, chat: data });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}


export function updateChatMetadata(data, successCB, errorCB) {
    return (dispatch) => {
        api.updateChatMetadata(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.CHAT_CREATE_SUCCESS, chat: data });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}
